import { SpeechEvent, SpeechEventName, SPEECH_EVENT, subscribeToSpeechEvents } from './speechManager'

import { isTrackableStudentEvent } from '../isTrackableStudentEvent'
import { CONNECT, DIAGNOSTIC, EVIDENCE, GRAMMAR, PROOFREADER } from '../../utils/constants'
import { fetchUserIdsForSession } from '../../utils/userAPIs'

export type ReadAloudTool = typeof CONNECT | typeof DIAGNOSTIC | typeof EVIDENCE | typeof GRAMMAR | typeof PROOFREADER

export const READ_ALOUD_ANALYTICS_EVENT: Record<SpeechEventName, string> = {
  [SPEECH_EVENT.DOWNLOADED]: 'readAloudDownloaded',
  [SPEECH_EVENT.FETCHED]: 'readAloudFetched',
  [SPEECH_EVENT.SELECTED]: 'readAloudEngineSelected',
  [SPEECH_EVENT.STALLED]: 'readAloudStalled',
  [SPEECH_EVENT.STARTED]: 'readAloudStarted',
}

interface AnalyticsClient {
  identify: (userId: string, traits: object) => void;
  track: (name: string, properties: object) => void;
}

const analyticsClient = (): AnalyticsClient | undefined => (window as Window & { analytics?: AnalyticsClient }).analytics

const currentPath = () => `${window.location.pathname}${window.location.search}${window.location.hash}`

export const startReadAloudAnalytics = ({ activitySessionUid, tool, }: { activitySessionUid?: string | null, tool: ReadAloudTool }) => {
  if (!activitySessionUid || !analyticsClient()) { return () => undefined }

  const ids = fetchUserIdsForSession(activitySessionUid).catch(() => null)
  let identified = false

  return subscribeToSpeechEvents(async ({ event, ...measurements }: SpeechEvent) => {
    const idData = await ids
    const client = analyticsClient()
    if (!client || !isTrackableStudentEvent(idData)) { return }

    const { studentId, teacherId, } = idData
    const name = READ_ALOUD_ANALYTICS_EVENT[event]
    if (!identified) {
      identified = true
      client.identify(teacherId, { event: name, })
    }
    client.track(name, { ...measurements, event: name, path: currentPath(), properties: { student_id: studentId, }, sessionID: activitySessionUid, tool, user_id: teacherId, })
  })
}
